export default {
  'tour.name': 'ツアー名',
  'tour.en.name': 'ツアー名英語',
  'tour.en.fa.name': 'ツアー名ペルシア語',
  'tour.englishTourName': 'ツアー名（英語）',
  'tour.persianTourName': 'ツアー名（ペルシア語）',
  'tour.necessities': '必需品英語',
  'tour.en.necessities': '英語の必需品',
  'tour.en.fa.necessities': 'ペルシア語の必需品',
  'tour.englishNecessities': '旅行に必要な必需品（英語）',
  'tour.persianNecessities': '旅行に必要な必需品（ペルシア語）',
  'tour.moneyUnit': 'マネーユニット',
  'tour.price': '価格',
  'tour.setPrice': 'セット価格',
  'tour.type': 'ツアータイプ',
  'tour.registerDate': '登録日',
  'tour.whether': 'どうにか',
  'tour.tourCondition': 'ツアーコンディション',
  'tour.passengerTypes': '乗客の種類',
  'tour.choosePassengerTypes': '乗客タイプを選択してください',
  'tour.capacity': 'ツアーの人数の定員',
  'tour.duration': 'ツアー期間（日）',
  'tour.destination': '行き先',
  'tour.destinationCity': '目的地の都市',
  'tour.destinationCountry': '仕向国',
  'tour.en.destination': '宛先名英語',
  'tour.en.fa.destination': '宛先名ペルシア語',
  'tour.description': '説明',
  'tour.en.description': '英語での説明',
  'tour.en.fa.description': 'ペルシア語での説明',
  'tour.englishDescription': '旅行に必要な詳細を記載してください（英語）',
  'tour.persianDescription': '旅行に必要な詳細に言及（ペルシア語）',
  'tour.limitaions': '制限事項',
  'tour.en.limitaions': '英語での制限',
  'tour.englishlimitaions': '旅行の制限（英語）',
  'tour.persianlimitaions': '旅行の制限（ペルシア語）',
  'tour.departure': '出発',
  'tour.departureCity': '出発都市',
  'tour.departureCountry': '出発国',
  'tour.en.departure': '英語での出発',
  'tour.en.fa.departure': 'ペルシア語での出発',
  'tour.difficultyRate': '旅行の難しさ',
  'tour.departureDate': 'ツアー開始時間',
  'tour.international': 'インターナショナル',
  'tour.domestic': '国内の',
  'tour.addTour': '新しいツアーを追加する',
  'tour.easy': '簡単',
  'tour.amature': 'アマチュア',
  'tour.normal': '普通',
  'tour.hard': '難しい',
  'tour.veryHard': 'とても厳しい',
  'tour.road': '道',
  'tour.flight': 'フライト',
  'tour.marine': 'マリン',
  'tour.transportTypes': 'トランスポートタイプ',
  'tour.chooseTransportTypes': 'トランスポートタイプを選択します',
  'tour.surpriseTour': 'サプライズツアー',
  'tour.ordinaryTour': '通常ツアー',
  'tour.next': '次の一歩',
  'tour.home': '家',
  'tour.confirm': '確認',
  'tour.previous': '一つ前の手順',
  'tour.active': 'アクティビティ',
  'tour.disable': '無効にする',
  'tour.dollar': '米ドル',
  'tour.euro': 'ユーロ',
  'tour.rial': 'リアル',
  'tour.stepOne': 'ステップ1',
  'tour.stepTwo': 'ステップ 2',
  'tour.stepThree': 'ステップ 3',
  'tour.stepFour': 'ステップ 4',
  'tour.stepFive': 'ステップ 5',
  'tour.details': '詳細',
  'tour.tourDetails': 'ツアーの詳細',
  'tour.cancel': 'キャンセル',
  'tour.chooseTourType': 'タイプを選択してください',
  'tour.save': '保存する',
  'tour.tourDetail': 'ツアー情報',
  'tour.furtherInformation': 'さらに詳しい情報',
  'tour.toddlerinownsitPrice': '自分の座る幼児の価格',
  'tour.infantPrice': '幼児の価格',
  'tour.childPrice': '子供の価格',
  'tour.adultPrice': '大人の価格',
  'tour.studentPrice': '学生の価格',
  'tour.seniorcitizenPrice': '高齢者の価格',
  'tour.bookingDeadline': 'ツアーの登録期限',
  'tour.climateType': '旅行中の天気',
  'tour.step': 'ステップ',
  'tour.tourclimateTitle': 'ツアー気候の選択',
  'tour.tourclimateDescription': 'あなたが望む天気のタイプを選択してください',
  'tour.tourtypeTitle': 'ツアータイプの選択',
  'tour.tourtypeDescription': '希望するツアーの種類を選択してください',
  'tour.tourtransfertypeTitle': 'ツアー輸送タイプ',
  'tour.tourtransfertypeDescription':
    '希望するツアー交通機関の種類を選択してください',
  'tour.tourpassengertypeTitle': 'ツアー乗客タイプ ',
  'tour.tourpassengertypeDescription':
    '希望するツアー旅行者のタイプを選択してください',
  'tour.tourinformationTitle': 'ツアー情報',
  'tour.tourinformationDescription': '完全なツアー情報を入力してください',
  'tour.touroverviewTitle': 'ツアー概要',
  'tour.touroverviewDescription': 'ツアー情報を確認し、必要に応じて編集します',
  'tour.tourpriceTitle': 'ツアー料金',
  'tour.overview': '概要 ',
  'tour.tourpriceDescription': '選択した各乗客の価格を入力します',
  'tour.tourScheduling': 'ツアーのスケジュール',
  'tour.mainTourInformation': '主なツアー情報',
  'tour.tourConditions': 'ツアー条件',
  'tour.tourRestrictionsRequirements': 'ツアーの制限と要件',
  'tour.tourRegistration': 'ツアー登録',
  'tour.addNewTour': '新しいツアーを追加する',
  'tour.name': 'ツアー名',
  'tour.en.name': 'ツアー名英語',
  'tour.en.fa.name': 'ツアー名ペルシア語',
  'tour.englishTourName': 'ツアー名（英語）',
  'tour.persianTourName': 'ツアー名（ペルシア語）',
  'tour.necessities': '必需品英語',
  'tour.en.necessities': '英語の必需品',
  'tour.en.fa.necessities': 'ペルシア語の必需品',
  'tour.englishNecessities': '旅行に必要な必需品（英語）',
  'tour.persianNecessities': '旅行に必要な必需品（ペルシア語）',
  'tour.moneyUnit': 'マネーユニット',
  'tour.price': '価格',
  'tour.setPrice': 'セット価格',
  'tour.type': 'ツアータイプ',
  'tour.registerDate': '登録日',
  'tour.whether': 'どうにか',
  'tour.tourCondition': 'ツアーコンディション',
  'tour.passengerTypes': '乗客の種類',
  'tour.choosePassengerTypes': '乗客タイプを選択してください',
  'tour.capacity': 'ツアーの人数の定員',
  'tour.duration': 'ツアー期間（日）',
  'tour.destination': '行き先',
  'tour.destinationCity': '目的地の都市',
  'tour.destinationCountry': '仕向国',
  'tour.en.destination': '宛先名英語',
  'tour.en.fa.destination': '宛先名ペルシア語',
  'tour.description': '説明',
  'tour.en.description': '英語での説明',
  'tour.en.fa.description': 'ペルシア語での説明',
  'tour.englishDescription': '旅行に必要な詳細を記載してください（英語）',
  'tour.persianDescription': '旅行に必要な詳細に言及（ペルシア語）',
  'tour.limitaions': '制限事項',
  'tour.en.limitaions': '英語での制限',
  'tour.englishlimitaions': '旅行の制限（英語）',
  'tour.persianlimitaions': '旅行の制限（ペルシア語）',
  'tour.departure': '出発',
  'tour.departureCity': '出発都市',
  'tour.departureCountry': '出発国',
  'tour.en.departure': '英語での出発',
  'tour.en.fa.departure': 'ペルシア語での出発',
  'tour.difficultyRate': '旅行の難しさ',
  'tour.departureDate': 'ツアー開始時間',
  'tour.international': 'インターナショナル',
  'tour.domestic': '国内の',
  'tour.addTour': '新しいツアーを追加する',
  'tour.easy': '簡単',
  'tour.amature': 'アマチュア',
  'tour.normal': '普通',
  'tour.hard': '難しい',
  'tour.veryHard': 'とても厳しい',
  'tour.road': '道',
  'tour.flight': 'フライト',
  'tour.marine': 'マリン',
  'tour.transportTypes': 'トランスポートタイプ',
  'tour.chooseTransportTypes': 'トランスポートタイプを選択します',
  'tour.surpriseTour': 'サプライズツアー',
  'tour.ordinaryTour': '通常ツアー',
  'tour.next': '次の一歩',
  'tour.home': '家',
  'tour.confirm': '確認',
  'tour.previous': '一つ前の手順',
  'tour.active': 'アクティビティ',
  'tour.disable': '無効にする',
  'tour.dollar': '米ドル',
  'tour.euro': 'ユーロ',
  'tour.rial': 'リアル',
  'tour.stepOne': 'ステップ1',
  'tour.stepTwo': 'ステップ 2',
  'tour.stepThree': 'ステップ 3',
  'tour.stepFour': 'ステップ 4',
  'tour.stepFive': 'ステップ 5',
  'tour.details': '詳細',
  'tour.tourDetails': 'ツアーの詳細',
  'tour.cancel': 'キャンセル',
  'tour.chooseTourType': 'タイプを選択してください',
  'tour.save': '保存する',
  'tour.tourDetail': 'ツアー情報',
  'tour.furtherInformation': 'さらに詳しい情報',
  'tour.toddlerinownsitPrice': '自分の座る幼児の価格',
  'tour.infantPrice': '幼児の価格',
  'tour.childPrice': '子供の価格',
  'tour.adultPrice': '大人の価格',
  'tour.studentPrice': '学生の価格',
  'tour.seniorcitizenPrice': '高齢者の価格',
  'tour.bookingDeadline': 'ツアーの登録期限',
  'tour.climateType': '旅行中の天気',
  'tour.step': 'ステップ',
  'tour.tourclimateTitle': 'ツアー気候の選択',
  'tour.tourclimateDescription': 'あなたが望む天気のタイプを選択してください',
  'tour.tourtypeTitle': 'ツアータイプの選択',
  'tour.tourtypeDescription': '希望するツアーの種類を選択してください',
  'tour.tourtransfertypeTitle': 'ツアー輸送タイプ',
  'tour.tourtransfertypeDescription':
    '希望するツアー交通機関の種類を選択してください',
  'tour.tourpassengertypeTitle': 'ツアー乗客タイプ ',
  'tour.tourpassengertypeDescription':
    '希望するツアー旅行者のタイプを選択してください',
  'tour.tourinformationTitle': 'ツアー情報',
  'tour.tourinformationDescription': '完全なツアー情報を入力してください',
  'tour.touroverviewTitle': 'ツアー概要',
  'tour.touroverviewDescription': 'ツアー情報を確認し、必要に応じて編集します',
  'tour.tourpriceTitle': 'ツアー料金',
  'tour.overview': '概要 ',
  'tour.tourpriceDescription': '選択した各乗客の価格を入力します',
  'tour.tourScheduling': 'ツアーのスケジュール',
  'tour.mainTourInformation': '主なツアー情報',
  'tour.tourConditions': 'ツアー条件',
  'tour.tourRestrictionsRequirements': 'ツアーの制限と要件',
  'tour.tourRegistration': 'ツアー登録',
  'tour.addNewTour': '新しいツアーを追加する',

  'tour.tourInformationTemporarilyRecorded':
    'ツアー情報は一時的に記録されています',
  'tour.yourTourSuccessfullyRegistered': 'ツアーが正常に登録されました',
  'tour.tourInformationTemporarilyRecorded':
    'ツアー情報は一時的に記録されています',
  'tour.yourTourSuccessfullyRegistered': 'ツアーが正常に登録されました',

  'tour.tourpassengertype': '乗客タイプ',
  'tour.tourtransfertype': 'ツアートランスファー',
  'tour.tourType': 'ツアータイプ',
  'tour.nameen': 'ツアー名（英語）',
  'tour.namefa': 'ツアー名（ペルシア語）',
  'tour.bookingDeadLine': 'ツアーの登録期限',
  'tour.climateTypes': 'ツアー気候',
  'tour.limitationsen': '旅行の制限（英語）',
  'tour.limitationsfa': '旅行の制限（ペルシア語）',
  'tour.necessitiesen': '旅行に必要な必需品（英語）',
  'tour.necessitiesfa': '旅行に必要な必需品（ペルシア語）',
  'tour.descriptionen': '旅行に必要な詳細を記載してください（英語）',
  'tour.descriptionfa': '旅行に必要な詳細に言及する（ペルシア語）',
  'tour.tourpassengertype': '乗客タイプ',
  'tour.tourtransfertype': 'ツアートランスファー',
  'tour.tourType': 'ツアータイプ',
  'tour.nameen': 'ツアー名（英語）',
  'tour.namefa': 'ツアー名（ペルシア語）',
  'tour.bookingDeadLine': 'ツアーの登録期限',
  'tour.climateTypes': 'ツアー気候',
  'tour.limitationsen': '旅行の制限（英語）',
  'tour.limitationsfa': '旅行の制限（ペルシア語）',
  'tour.necessitiesen': '旅行に必要な必需品（英語）',
  'tour.necessitiesfa': '旅行に必要な必需品（ペルシア語）',
  'tour.descriptionen': '旅行に必要な詳細を記載してください（英語）',
  'tour.descriptionfa': '旅行に必要な詳細に言及する（ペルシア語）',

  'tour.editTourTransferType': 'ツアー転送情報の編集',
  'tour.editTourPassengerType': '各乗客の乗客情報と価格を編集する',
  'tour.editTourInformation': '一般的なツアー情報を編集する',
  'tour.tourRegistration': 'ツアー登録',
  'tour.isActive': 'アクティビティ',
  'tour.editTourPassengerType': 'ツアーの乗客タイプを編集する',
  'tour.editTourTransferType': 'ツアー転送タイプの編集',
  'tour.editTourInformationType': 'ツアー情報の編集',
  'tour.editTourPrice': '乗客価格の編集',
  'tour.attachments': '添付ファイル',
  'tour.cancelingRules': 'ルールのキャンセル',

  'tour.endBookingDeadLine': '予約期限の終了',
  'tour.endPrice': '終了価格',
  'tour.startPrice': '開始価格',
  'tour.endDuration': '終了期間',
  'tour.startDuration': '開始期間',
  'tour.endDepartureDate': '出発終了日',
  'tour.startDepartureDate': '出発開始日',
  'tour.originterminal': '発信元端末',
  'tour.destinationterminal': '宛先端末',
  'tour.vehicletype': '車種',
  'tour.starttime': '始まる時間',
  'tour.endtime': '終了時間',
  'tour.invalidreturndate': '終了日が開始日より小さい',
  'tour.invalidstartdate': '開始日が終了日より後である',
  'tour.facilities': '見学施設',
  'tour.invalidEndTime': '終了時刻が開始時刻より短い',
  'tour.drafts': '下書き',
  'tour.useprevioustours': '過去のツアーを利用する',
  'tour.Draft': 'ドラフトツアー',
  'tour.creationDate': '作成日',
  'tour.dateCreatedFrom': '作成日',
  'tour.dateCreatedUntil': '作成日',
  'tour.ordering': '注文',
  'tour.basedTourName': 'ツアー名に基づく',
  'tour.basedNamePlace': '地名をもとに',
  'tour.search': '名前と場所で検索',
  'tour.facilitynotdeclared': '施設が宣言されていない',
  'tour.basicinfonotfound': 'ツアー情報は指定されていません',
  'tour.finaldestination': '最終目的地',
  'tour.insertdraft': 'ドラフトを挿入',
  'tour.updatetdraft': 'ドラフトを更新する',
  'tour.ageSuffering': '年齢の苦しみ',
  'tour.finaldestination': '最終目的地',
  'tour.insertsuccess': 'ツアーは正常に登録されました',
  'tour.draftinsertsuccess': 'ツアードラフトは正常に登録されました',
  'tour.inserterror': 'ツアーの申し込みに失敗しました',
  'tour.updatesuccess': 'ツアーは正常に更新されました',
  'tour.draftupdatesuccess': 'ツアードラフトは正常に更新されました',
  'tour.updateerror': 'ツアーの更新に失敗しました',
  'tour.deletesuccess': 'ツアーは正常に削除されました',
  'tour.draftdeletesuccess': 'ツアードラフトは正常に削除されました',
  'tour.deleteerror': 'ツアーの削除に失敗しました',
  'tour.deletedrafttour': 'ドラフトツアーを削除する',
  'tour.deletedrafttourmessage': 'ドラフトツアーを削除してもよろしいですか?',
  'tour.male': '男',
  'tour.female': '女性',
  'tour.all': '全て',
  'tour.changefieldwarning':
    '重要な項目を変更した場合、次のステップの情報は削除されます。 詳細についてはクリックしてください',
  'tour.importantfieldsintroduction':
    '次のフィールドに変更を適用すると、次のフォームのデータが失われます',
  'tour.tournotspecified': 'ツアー情報は指定されていません',
  'tour.stoptype': '停止タイプ',
  'tour.searchfacilities': '検索施設',
  'tour.confirmdata': '登録情報はすべて確認されます',
  'tour.vehiclenamefa': '現地の車両名',
  'tour.vehiclenameen': '英語の車名',
  'tour.transportproviderlocal': 'トランスポートプロバイダーのローカル名',
  'tour.transportprovideren': 'トランスポートプロバイダーの英語名',
  'tour.addnewtourtype': '新しいツアータイプを追加',
  'tour.submittourtype': '新しいツアー タイプを送信する',
  'tour.tourtypenamefa': 'ツアータイプのペルシア語名',
  'tour.tourtypenameen': 'ツアータイプの英語名',
  'tour.tourtypeinsertsuccess': '挿入成功',
  'tour.tourtypeinserterror': '挿入に失敗しました',
  'tour.originairport': '出発空港',
  'tour.destinationairport': '目的地の空港',
  'tour.arrivaldateto': '到着日',
  'tour.arrivaltimeto': '到着時刻',
  'tour.nextmovedate': '次回輸送開始日',
  'tour.nextmovetime': '次回輸送開始時刻',
  'tour.tourimages': 'ツアーの画像',
  'tour.viewimages': '画像を見る',
  'tour.addnewtourfacility': '新しいツアー施設の追加',
  'tour.tourfacilitynamefa': 'ツアー施設のペルシア語名',
  'tour.tourfacilitynameen': 'ツアー施設の英語名',
  'tour.originterminalfa': '発信元端末のローカル名',
  'tour.originterminalen': '発信端末の英語名',
  'tour.destinationterminalfa': '宛先端末のローカル名',
  'tour.destinationterminalen': '宛先端末の英語名',
  'tour.underreviewing': '検討中',
  'tour.expired': '期限切れ',
  'tour.residence': '住居',
  'tour.pricepercustomer': '1人あたりの料金',
  'tour.userstours': '私のツアー',
  'tour.usersalltours': 'すべてのツアー',
  'tour.usersactivetours': 'アクティブツアー',
  'tour.usersexpiredtours': '期限切れのツアー',
  'tour.changerequiredfields': 'オペレーターのレビュー結果を表示',
  'tour.requiredreviews': '必要なレビュー',
  'tour.rejectionreason': '拒否理由',
  'tour.rejectiondescription': '拒否の説明',
  'tour.starttime': '始まる時間',
  'tour.endtime': '終了時間',
  'tour.imageuploadfailed': '画像のアップロードに失敗しました',
};
